// useVuetify.ts
import { computed, getCurrentInstance } from "vue"

/**
 * returns the current vuetify instance
 */
export function useVuetify() {
  const instance = getCurrentInstance()
  if (!instance) {
    throw new Error(`useVuetify should be called in setup().`)
  }
  return instance.proxy.$vuetify
}

/**
 * returns a computed property that is the current vuetify breakpoint name
 */
export function useVuetifyBreakpointName() {
  const vuetify = useVuetify()
  return computed(() => vuetify.breakpoint.name)
}

/**
 * @param names - array of vuetify breakpoint names. e.g. ['xs', 'sm', 'md', 'lg', 'xl']
 *
 * returns a computed property that is true if the current breakpoint name is in the array
 */
export function useIsBreakpointInNames(names: string[]) {
  const breakpointName = useVuetifyBreakpointName()
  return computed(() => names.includes(breakpointName.value))
}

export function useIsMobile() {
  return useIsBreakpointInNames(["xs", "sm"])
}

export function useVuetifyTheme() {
  const vuetify = useVuetify()
  return vuetify.theme.currentTheme
}
